import styled from 'styled-components';

export default styled.h3`
  text-align: center;
  font-weight: bold;
  margin-bottom: 0.25rem;
`;
